import "./style.css";

export const ModeSwitchIcons = () => (
  <>
    <span className="mode-switch__icon mode-switch__icon--sun" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4.25" />
          <path d="M12 2.75v2" />
          <path d="M12 19.25v2" />
          <path d="M2.75 12h2" />
          <path d="M19.25 12h2" />
          <path d="M5.3 5.3l1.4 1.4" />
          <path d="M17.3 17.3l1.4 1.4" />
          <path d="M18.7 5.3l-1.4 1.4" />
          <path d="M6.7 17.3l-1.4 1.4" />
        </g>
      </svg>
    </span>
    <span className="mode-switch__icon mode-switch__icon--moon" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"
        />
      </svg>
    </span>
  </>
);
